<template>
  <div >
    <v-navigation-drawer  v-model="drawer" app clipped v-if="loggedIn">
    
      
      
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'game-transactions'}">
            <v-list-item-icon>
              <v-icon>mdi-comment-question-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Answers</v-list-item-title>
          </v-list-item>
        </v-list>
        
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'questions'}">
            <v-list-item-icon>
              <v-icon>mdi-head-question-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Questions</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'questionview'}">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-list</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Questions List</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'lasttwohundredquestions'}">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-list</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Last 200 Questions List</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'features'}">
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Features</v-list-item-title>
          </v-list-item>
        </v-list>
          <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'userslist'}">
            <v-list-item-icon>
              <v-icon>mdi-head-question-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list nav dense  v-if="isAdmin">
          <v-list-item link :to="{name: 'botusers'}">
            <v-list-item-icon>
              <v-icon>mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bot Users</v-list-item-title>
          </v-list-item>
        </v-list>
        <div class="pa-2">
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title name-title">{{name}}</v-list-item-title>
                <v-list-item-subtitle>{{email}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="loggedIn" />
      <v-img :src="logo" contain aspect-ratio="1.5" max-width="100"></v-img>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <!--
        <v-btn color="themebtn" v-if="!loggedIn" :to="{name: 'login'}">Login</v-btn>
      <v-btn color="themebtn" v-if="!loggedIn" :to="{name: 'register'}">Register</v-btn>-->
      <v-btn color="themebtn" v-if="loggedIn" :to="{name: 'logout'}">Logout</v-btn>
    </v-app-bar>

    <v-content dark>
      <router-view />
    </v-content>
  </div>
</template>


<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    name() {
      return this.$store.getters.name;
    },
    email() {
      return this.$store.getters.email;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  data() {
    return {
      drawer: null,
      logo: require("@/assets/damnn_group_header.png")
    };
  },
  created() {
    this.$vuetify.theme.dark = false;
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    getUserData() {
      this.$store.dispatch("retrieveUserDetails");
    }
  }
};
</script>

<style scoped>
.v-btn {
  margin-left: 10px;
}
.name-title {
  text-transform: capitalize;
}
</style>
<style >
.themebtn{
  color:#fff !important
}
.theme--light.v-sheet{
  color:#fff !important
}
.v-application a {
  color:#6f42c1 !important;
}
.theme--dark.v-card{
  background-color: #6f42c1 !important;
    color: #FFFFFF;
}
.theme--dark.v-list{
  background-color: #6f42c1 !important;
}
</style>
